<template>
  <div class="zgh">
    <div class="top">
      <h2>类型：</h2>
      <span class="active">征稿函</span>
    </div>
    <Item
      class="bottom"
      v-for="item in itemList3"
      :key="item.id"
      :curcer="item.articleId"
      :every="item"
      @itemClick="goDetail"
    ></Item>
    <Paging
      :total="total"
      :curPage="curPage"
      :limit="limit"
      :showPage="5"
      @changePager="handlePager"
    ></Paging>
  </div>
</template>

<script>
import Item from "./Item.vue";
import Paging from "@/components/paging";
export default {
  components: {
    Item,
    Paging,
  },
  data() {
    return {
      index: 0,
      // 分页
      curPage: 1,
      total: 0,
      limit: 0,
      itemList3: [], // 征稿函列表
    };
  },
  created() {
    console.log("created", this);
    this.getUserCollectSolicitationList();
  },
  methods: {
    handlePager(newPage) {
      this.curPage = newPage;
      this.getUserCollectSolicitationList({
        pageNo: newPage,
      });
      document.documentElement.scrollTop = 0;
    },
    // 征稿函列表
    async getUserCollectSolicitationList(data) {
      const resp = await this.$apis.userServe.getUserCollectSolicitationList(
        data
      );
      if (resp.data) {
        this.total = +resp.data.total;
        this.limit = +resp.data.pageSize;
        this.itemList3 = resp.data.list;
      }
    },
    goDetail(e) {
      console.log("godetail", e);
      let routeUrl = this.$router.resolve({
        path: "/solicitationDetails",
        query: {
          id: e.id,
          type: 10
        },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.zgh {
  width: 1200px;
  .bottom {
    background-color: #fff;
    padding: 37px 49px 19px 37px;
  }
  .top {
    display: flex;
    margin: 40px 0;
    h2 {
      vertical-align: middle;
      font-size: 14px;
      color: #333;
      font-weight: 400;
    }
    span {
      margin: 0 10px;
      cursor: pointer;
      &.active {
        color: #0101f3;
      }
    }
  }
}
</style>
